import React from 'react';
import {
 Card, CardContent, CardHeader, CardTitle
} from 'shared/components/ui/card';
import {
 Activity
} from 'lucide-react';

const DashboardActivityFeed: React.FC = () => {
    return (
        <Card>
            <CardHeader>
                <CardTitle className="text-lg flex items-center gap-2">
                    <Activity className="h-5 w-5" />
                    Recent Activity
                </CardTitle>
            </CardHeader>
            <CardContent>
                <div className="flex flex-col items-center justify-center py-8 text-muted-foreground">
                    <Activity className="h-8 w-8 mb-2 opacity-50" />
                    <p className="text-sm">No recent activity to show</p>
                    <p className="text-xs mt-1">Activity from schemas, connections, and workflows will appear here.</p>
                </div>
            </CardContent>
        </Card>
    );
};

export default DashboardActivityFeed;
